






















import Vue from "vue";

export default Vue.extend({
  name: "cwx-icon",

  props: {
    //Adds to <i> the class 'cwx-icon-fixed-width'
    fixedWidth: {
      type: Boolean,
      required: false,
      default: false
    },
    //Adds to <i> the class 'cwx-icon--link'
    link: {
      type: Boolean,
      required: false,
      default: false
    },
    //Adds to <i> the class 'cwx-icon--disabled'
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    color: {
      type: String,
      required: false,
      default: undefined
    }
  },

  data() {
    return {
      classesForIcon: ""
    };
  },

  methods: {
    takeClassesForIcon(): void {
      if (this.$slots.default)
        this.classesForIcon = this.$slots.default[0].text!.trim();
    }
  }
});
